import { useCallback, useState } from 'react';
import { ensureFileExtension } from 'utils/files';

export const useFileDownload = () => {
  const [progress, setProgress] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const download = useCallback(
    async ({ url, filename }: { url: string; filename: string }) => {
      setIsLoading(true);
      setProgress(0);

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Ошибка при скачивании файла');
        }

        const contentLength = +response.headers.get('Content-Length')!;
        const reader = response.body?.getReader();

        if (!reader) {
          throw new Error('ReadableStream не поддерживается');
        }

        const chunks: Uint8Array[] = [];
        let receivedLength = 0;

        while (true) {
          const { done, value } = await reader.read();

          if (done) {
            break;
          }
          chunks.push(value!);
          receivedLength += value!.length;

          if (contentLength) {
            setProgress(Math.round((receivedLength / contentLength) * 100));
          }
        }

        const typedChunks: BlobPart[] = chunks.map((c) => new Uint8Array(c));
        const blob = new Blob(typedChunks);
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        // Имя без расширения (например, фото из мессенджера без имени)
        // дополняем по Content-Type ответа
        a.download = ensureFileExtension(
          filename,
          response.headers.get('content-type')?.split(';')[0].trim() ?? ''
        );
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error(error);

        return Promise.reject(error);
      } finally {
        setIsLoading(false);
        setProgress(0);
      }
    },
    []
  );

  return { download, isLoading, progress };
};
